import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Box,
  Typography,
  Paper,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import { BsArrowRight } from "react-icons/bs";
import FileUploadWithPreview from "../common/FileUploadWithPreview";
import { vendorApi } from "../../api/api";
// import LeafletMapPicker from "../common/LeafletMapPicker";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const AddPropertyModel = () => {
  const navigate = useNavigate();
  const [propertyType, setPropertyType] = useState("Property");
  const [propertyName, setPropertyName] = useState("");
  const [sizeInSqFt, setSizeInSqFt] = useState("");
  const [unitPrice, setUnitPrice] = useState("");
  const [projectName, setProjectName] = useState("");
  const [files, setFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [ImagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [propertyErrors, setPropertyErrors] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const fileInputRef = useRef();
  const [projectOptions, setProjectOptions] = useState([]);
  const [facing, setFacing] = useState("");
  const [bedroomcount, setBedRoomCount] = useState(0);
  const [bathroomcount, setBathRoomCount] = useState(0);
  const [parking, setParking] = useState("yes");
  const [landarea, setLandArea] = useState("");
  const [noofFloors, setNoOfFloors] = useState(0);
  const [parkingType, setParkingType] = useState("bike");
  const [ageOfBuilding, setAgeOfBuilding] = useState(0);
  const [waterSupply, setWaterSupply] = useState("");
  const [balcony, setBalcony] = useState(0);
  const [powerBackup, setPowerBackup] = useState("");
  const [totalPrice, setTotalPrice] = useState(0);
  const [description, setDescription] = useState("");
  const [youtubeLinks, setYoutubeLinks] = useState([""]);

  const [priceMode, setPriceMode] = useState(""); // percentage | sqft
  const [extraValue, setExtraValue] = useState("");
  const [calculatedAmount, setCalculatedAmount] = useState(0);

   /* ---------------- QUILL CONFIG ---------------- */
  const quillModules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"],
    ],
  };

  const quillFormats = [
    "header",
    "bold",
    "italic",
    "underline",
    "list",
    "bullet",
    "link",
  ];


  // Owner Details
  const [ownerName, setOwnerName] = useState("");
  const [ownerMobile, setOwnerMobile] = useState("");
  const [ownerEmail, setOwnerEmail] = useState("");
  const [ownerAddress, setOwnerAddress] = useState("");

  // Reference Details
  const [referenceName, setReferenceName] = useState("");
  const [referenceMobile, setReferenceMobile] = useState("");

 
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
 


  useEffect(() => {
    if (!totalPrice || !extraValue) {
      setCalculatedAmount(0);
      return;
    }

    if (priceMode === "percentage") {
      setCalculatedAmount((totalPrice * Number(extraValue)) / 100);
    }

    if (priceMode === "sqft") {
      setCalculatedAmount(Number(extraValue) * Number(sizeInSqFt));
    }
  }, [priceMode, extraValue, totalPrice, sizeInSqFt]);

  const propertyTypeOptions = [
    { label: "Individual", value: "Property" },
    { label: "Project", value: "Project" },
    { label: "Individual Villa", value: "Individual Villa" }
  ];

  const getYoutubeEmbedUrl = (url) => {
  const match = url.match(
    /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/
  );
  return match ? `https://www.youtube.com/embed/${match[1]}` : null;
};

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);

    // Prevent duplicate files
    const newFiles = selectedFiles.filter(
      (file) => !files.some((existingFile) => existingFile.name === file.name)
    );

    const newPreviews = newFiles.map((file) => URL.createObjectURL(file));

    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    setPreviews((prevPreviews) => [...prevPreviews, ...newPreviews]);

    event.target.value = null;
  };

  const handleRemove = (index) => {
    const updatedFiles = files.filter((_, i) => i !== index);
    const updatedPreviews = previews.filter((_, i) => i !== index);
    setFiles(updatedFiles);
    setPreviews(updatedPreviews);
  };

  const handleDisplayImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };


  const validate = () => {
    const errors = {};

    if (!propertyName) errors.propertyName = "Please enter a property name.";
    if (!city) errors.city = "Please enter a city name.";
    if (!address) errors.address = "Please enter an address.";
    if (!facing) errors.facing = "Please enter facing direction.";

    if (!sizeInSqFt || sizeInSqFt <= 0)
      errors.sizeInSqFt = "Please enter a valid size in square feet.";

    if (propertyType === "Property" || propertyType === "Project") {
      if (!unitPrice || unitPrice <= 0)
        errors.unitPrice = "Please enter a valid unit price.";
    }

    if (propertyType === "Project" && !projectName)
      errors.projectName = "Please select a project name.";

    if (propertyType === "Individual Villa") {
      if (!totalPrice || totalPrice <= 0)
        errors.unitPrice = "Please enter the total price.";

      if (!bedroomcount || bedroomcount <= 0)
        errors.bedroomcount = "Please enter number of bedrooms.";
      if (!bathroomcount || bathroomcount <= 0)
        errors.bathroomcount = "Please enter number of bathrooms.";
      if (!landarea || landarea <= 0)
        errors.landarea = "Please enter the land area.";
      if (!noofFloors || noofFloors <= 0)
        errors.noofFloors = "Please enter the number of floors.";
      if (!powerBackup) errors.powerBackup = "Please enter power backup info.";
      if (!waterSupply) errors.waterSupply = "Please enter water supply info.";
      if (!balcony) errors.balcony = "Please enter Balcony info";
      if (!ageOfBuilding) errors.ageOfBuilding = "Please enter age of building";
    }

    if (
      files.length === 0 &&
      (propertyType === "Property" || propertyType === "Individual Villa")
    )
      errors.files = "Please upload at least one gallery image.";

    if (!selectedImage)
      errors.displayImage = "Please select a display image.";

    setPropertyErrors(errors);

    // 🔹 Show the first error in Snackbar
    if (Object.keys(errors).length > 0) {
      const firstError = Object.values(errors)[0];
      setSnackbarMessage(firstError);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return false;
    }

    return true;
  };





  const saveProperty = async (event) => {
    debugger
    event.preventDefault();
    const errors = {};

    // ---------- Custom validation ----------
    if ((propertyType === "Property" || propertyType === "Project") && totalPrice > 0) {
      if (!priceMode) {
        errors.priceMode = "Please select calculation type.";
      }

      if (!extraValue || Number(extraValue) <= 0) {
        errors.extraValue = "Please enter a valid value.";
      }
    }


    if (!validate()) return;
    debugger

    setLoading(true);

    const formData = new FormData();
    formData.append("PropertyType", propertyType);
    formData.append("PropertyName", propertyName);

    formData.append("ProjectName", projectName);
    formData.append("City", city);
    formData.append("Address", address);
    formData.append("Facing", facing);
    formData.append("SizeInSqFt", sizeInSqFt);
    formData.append("SqFtPrice", unitPrice);

    formData.append("owner_name", ownerName);
    formData.append("owner_mobile", ownerMobile);
    formData.append("owner_email", ownerEmail);
    formData.append("owner_address", ownerAddress);

    formData.append("reference_name", referenceName);
    formData.append("reference_mobile", referenceMobile);


    formData.append(
      "percentagevalue",
      priceMode === "percentage" ? String(extraValue) : ""
    );

    formData.append(
      "sqftamount",
      priceMode === "sqft" ? String(extraValue) : ""
    );

   formData.append("Description", description);


    // If property type is 'Project', append project name
    if (propertyType === "Project") {
      const selected = projectOptions.find(p => p.id === projectName);
      formData.append("ProjectName", selected?.project_name || "");
    }
    formData.append("projectId",projectName);

    files.forEach((file) => {
      formData.append("images[]", file); // Append files to FormData
    });
    formData.append(
  "youtube_links",
  JSON.stringify(youtubeLinks.filter(link => link.trim() !== ""))
);

    // Handle the selected display image (iconUrl)
    if (selectedImage) {
      formData.append("iconUrl", selectedImage); // Ensure this is handled correctly in Laravel
    }
    // if(propertyType === "Property" || propertyType === "Individual Villa") {
    //   formData.append("GeoLocation",geoLocation);
    // }
    if (propertyType === "Individual Villa") {
      formData.append("TotalPrice", totalPrice);
    }

    if (propertyType === "Individual Villa") {
      const ExtraData = {
        Bedrooms: bedroomcount,
        Bathrooms: bathroomcount,
        ParkingAvailable: parking,
        LandAreaInSqFt: landarea,
        NoOfFloors: noofFloors,
        WaterSupply: waterSupply,
        PowerBackUp: powerBackup,
        AgeOfBuilding: ageOfBuilding,
        Balcony: balcony
      };

      if (parking === "yes") {
        ExtraData.ParkingType = parkingType;
      }

      formData.append("ExtraData", JSON.stringify(ExtraData));
    }

    try {
      for (let pair of formData.entries()) {
        console.log(pair[0], ":", pair[1]);
      }
      const response = await vendorApi.addProperty(formData);
      setSnackbarMessage("Property added successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      resetForm();
      setTimeout(() => {
        navigate("/property");
      }, 2000);
    } catch (error) {
      setSnackbarMessage("Failed to add property. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setPropertyName("");
    setCity("");
    setAddress("");
    setSizeInSqFt("");
    setUnitPrice("");
    setProjectName("");
    setDescription("");
    setFiles([]);
    setPreviews([]);
    setSelectedImage(null);
    setPropertyErrors({});
  };

  useEffect(() => {
    if (unitPrice > 0 && sizeInSqFt > 0) {
      const total = Number(unitPrice) * Number(sizeInSqFt);
      setTotalPrice(total);
    } else {
      setTotalPrice(0);
    }
  }, [unitPrice, sizeInSqFt]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await vendorApi.getAllProjectsName();
        setProjectOptions(res.data.data);
      } catch (error) {
        console.error("Failed to load projects", error);
      }
    };

    // if (propertyType === "Project") {
    fetchProjects();
    // }
  }, []);


  return (
    <Box sx={{ padding: 3 }}>
      <Backdrop open={loading} sx={{ zIndex: 1300 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          sx={{ color: "#13216e", fontWeight: 600, fontSize: "24px" }}
        >
          Add Property
        </Typography>
        <Box>
          <Link
            to="/home"
            style={{
              textDecoration: "none",
              color: "#4e0dff",
              fontSize: "18px",
            }}
          >
            Home
          </Link>
          <BsArrowRight style={{ margin: "-2px 8px", color: "#4e0dff" }} />
          <Link
            to="/property"
            style={{
              textDecoration: "none",
              color: "#4e0dff",
              fontSize: "18px",
            }}
          >
            Property
          </Link>
        </Box>
      </Box>

      <Paper elevation={3} sx={{ padding: 3 }}>
        <form onSubmit={saveProperty}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Property Type</InputLabel>
                <Select
                  value={propertyType}
                  onChange={(event) => setPropertyType(event.target.value)}
                  label="Property Type"
                >
                  {propertyTypeOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Conditional rendering of Project Name dropdown */}
            {propertyType === "Project" && (
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel>Project Name</InputLabel>
                  <Select
                    value={projectName}
                    onChange={(e) => {
                      const projectId = e.target.value;
                      const selected = projectOptions.find((p) => p.id === projectId);

                      setProjectName(projectId);        // ✅ store ID
                      setCity(selected?.city || "");
                      setAddress(selected?.address || "");
                     
                    }}
                  >
                    {projectOptions.map((p) => (
                      <MenuItem key={p.id} value={p.id}>
                        {p.project_name}
                      </MenuItem>
                    ))}
                  </Select>

                  {propertyErrors.projectName && (
                    <Typography color="error">{propertyErrors.projectName}</Typography>
                  )}
                </FormControl>
              </Grid>
            )}

            <Grid item xs={12}>
              <TextField
                label="Property Name"
                fullWidth
                value={propertyName}
                onChange={(e) => setPropertyName(e.target.value)}
                error={!!propertyErrors.propertyName}
                helperText={propertyErrors.propertyName}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="City"
                fullWidth
                value={city}
                onChange={(e) => setCity(e.target.value)}
                error={!!propertyErrors.city}
                helperText={propertyErrors.city}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Address"
                fullWidth
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                error={!!propertyErrors.address}
                helperText={propertyErrors.address}
              />
            </Grid>

            {(propertyType === "Property" || propertyType === "Individual Villa" || propertyType === "Project") && (

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Facing"
                  value={facing}
                  onChange={(event) => setFacing(event.target.value)}
                  error={!!propertyErrors.facing}
                  helperText={propertyErrors.facing}
                />

              </Grid>
            )}
            {/* {(propertyType === "Property" || propertyType === "Individual Villa") && (
              <>
                <Grid item xs={12}>
                  <Button
                    onClick={() => setShowMap(!showMap)}
                    style={{
                      backgroundColor: showMap ? "#f44336" : "#4caf50",
                      color: "white",
                      padding: "6px 12px",
                      border: "none",
                      borderRadius: "10px",
                      cursor: "pointer",
                      fontWeight: "bold",
                      fontSize: "12px",
                      fontVariant: "small-caps", // corrected small caps
                      transition: "background-color 0.3s ease",
                      textTransform: "none",
                    }}
                  >
                    {showMap ? "Hide Map" : "Pick Location on Map"}
                  </Button>

                  {showMap && (
                    <Box sx={{ height: 400, width: "100%", marginY: 2 }}>
                      <LeafletMapPicker onLocationSelect={handleLocationSelect} setGeoLocation={setGeoLocation}
                      />
                      <p>Geo Location: {geoLocation.lat}, {geoLocation.lng}</p>
                    </Box>
                  )}


                </Grid>
              </>
            )} */}
            {/* <Grid item xs={12}>
              <TextField
                fullWidth
                label="Geolocation (Lat,Lng)"
                value={geoLocation}
                onChange={(e) => setGeoLocation(e.target.value)}
                margin="normal"
              />
            </Grid> */}
            <Grid item xs={12}>
              <TextField
                label={
                  propertyType === "Individual Villa"
                    ? "Built-up Area (Sq Ft)"
                    : "Size In SqFt"
                }
                fullWidth
                type="number"
                value={sizeInSqFt}
                onChange={(e) => setSizeInSqFt(e.target.value)}
                error={!!propertyErrors.sizeInSqFt}
                helperText={propertyErrors.sizeInSqFt}
              />
            </Grid>

            {(propertyType === "Property" || propertyType === "Project") && (
              <Grid item xs={12}>
                {/* Unit Price */}
                <TextField
                  label="Unit Price"
                  fullWidth
                  type="number"
                  value={unitPrice}
                  onChange={(e) => setUnitPrice(e.target.value)}
                  error={!!propertyErrors.unitPrice}
                  helperText={propertyErrors.unitPrice}
                />




                {/* {totalPrice > 0 && (
                  <Typography sx={{ mt: 1, fontWeight: 600, color: "#2e7d32" }}>
                    Total Price: ₹ {totalPrice.toLocaleString("en-IN")}
                  </Typography>
                )}
                {calculatedAmount > 0 && (
                  <Typography
                    sx={{
                      mt: 2,
                      fontWeight: 700,
                      color: "#1565c0"
                    }}
                  >
                    Calculated Amount: ₹ {calculatedAmount.toLocaleString("en-IN")}
                  </Typography>
                )} */}
              </Grid>
            )}



            {(propertyType === "Individual Villa") && (
              <Grid item xs={12}>
                <TextField
                  label="Property Price"
                  fullWidth
                  type="text"
                  value={totalPrice}
                  onChange={(e) => setTotalPrice(e.target.value)}
                  error={!!propertyErrors.unitPrice}
                  helperText={propertyErrors.unitPrice}
                />
              </Grid>

            )}
            {totalPrice > 0 && (
              <Grid container spacing={2} sx={{ mt: 2, marginLeft: 2 }}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    label="Percentage Type"
                    fullWidth
                    value={priceMode}
                    onChange={(e) => {
                      setPriceMode(e.target.value);
                      setExtraValue("");
                      setCalculatedAmount(0);
                    }}
                  >
                    <MenuItem value="percentage">Percentage (%)</MenuItem>
                    <MenuItem value="sqft">Sqft Amount</MenuItem>
                  </TextField>
                </Grid>


                {priceMode && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label={
                        priceMode === "percentage"
                          ? "Enter Percentage (%)"
                          : "Enter Amount per Sqft"
                      }
                      fullWidth
                      type="number"
                      value={extraValue}
                      onChange={(e) => setExtraValue(e.target.value)}
                    />
                  </Grid>
                )}
              </Grid>
            )}
            {propertyType === "Individual Villa" && (
              <Grid container spacing={2} sx={{ paddingLeft: 3, paddingTop: 3 }}>
                {/* Row 1: Bedrooms and Bathrooms */}
                <Grid item xs={6} >
                  <TextField
                    label="No. of Bedrooms"
                    fullWidth
                    type="number"
                    value={bedroomcount}
                    onChange={(e) => setBedRoomCount(e.target.value)}
                    error={!!propertyErrors.bedroomcount}
                    helperText={propertyErrors.bedroomcount}
                  />

                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="No. of Bathrooms"
                    fullWidth
                    type="number"
                    value={bathroomcount}
                    onChange={(e) => setBathRoomCount(e.target.value)}
                    error={!!propertyErrors.bathroomcount}
                    helperText={propertyErrors.bathroomcount}

                  />
                </Grid>

                {/* Row 2: Parking, Land Area, Floors */}
                <Grid container spacing={2} sx={{ paddingLeft: 2 }}>
                  {/* Parking Available */}
                  <Grid item xs={parking === "yes" ? 6 : 12}>
                    <TextField
                      select
                      label="Parking Available"
                      fullWidth
                      value={parking}
                      onChange={(e) => setParking(e.target.value)}
                      margin="normal"
                    >
                      <MenuItem value="yes">Yes</MenuItem>
                      <MenuItem value="no">No</MenuItem>
                    </TextField>
                  </Grid>

                  {/* Parking Type - shown only if Parking Available is "yes" */}
                  {parking === "yes" && (
                    <Grid item xs={6}>
                      <TextField
                        select
                        label="Parking Type"
                        fullWidth
                        value={parkingType}
                        onChange={(e) => setParkingType(e.target.value)}
                        margin="normal"
                      >
                        <MenuItem value="car">Car</MenuItem>
                        <MenuItem value="bike">Bike</MenuItem>
                        <MenuItem value="both">Both</MenuItem>
                      </TextField>
                    </Grid>
                  )}
                </Grid>


                <Grid item xs={4}>
                  <TextField
                    label="Land Area in SqFt"
                    fullWidth
                    type="number"
                    value={landarea}
                    onChange={(e) => setLandArea(e.target.value)}
                    margin="normal"
                    error={!!propertyErrors.landarea}
                    helperText={propertyErrors.landarea}
                  />
                </Grid>

                <Grid item xs={4}>
                  <TextField
                    label="No. of Floors"
                    fullWidth
                    type="number"
                    value={noofFloors}
                    onChange={(e) => setNoOfFloors(e.target.value)}
                    margin="normal"
                    error={!!propertyErrors.noofFloors}
                    helperText={propertyErrors.noofFloors}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    name="ageOfBuilding"
                    label="ageOfBuilding"
                    fullWidth
                    type="number"
                    value={ageOfBuilding}
                    onChange={(e) => setAgeOfBuilding(e.target.value)}
                    margin="normal"
                    error={!!propertyErrors.ageOfBuilding}
                    helperText={propertyErrors.ageOfBuilding}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    name="balcony"
                    label="Balcony"
                    fullWidth
                    type="number"

                    value={balcony}

                    onChange={(e) => setBalcony(e.target.value)}
                    margin="normal"
                    error={!!propertyErrors.balcony}
                    helperText={propertyErrors.balcony}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    name="powerBackup"
                    label="Power Backup"
                    fullWidth
                    value={powerBackup}
                    onChange={(e) => setPowerBackup(e.target.value)}
                    margin="normal"
                    error={!!propertyErrors.powerBackup}
                    helperText={propertyErrors.powerBackup}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    name="waterSupply"
                    label="Water Supply"
                    fullWidth
                    value={waterSupply}
                    onChange={(e) => setWaterSupply(e.target.value)}
                    margin="normal"
                    error={!!propertyErrors.waterSupply}
                    helperText={propertyErrors.waterSupply}
                  />
                </Grid>

              </Grid>
            )}

  
              <>
                {/* Owner Details */}
                <Grid item xs={12}>
                  <Typography variant="h6" sx={{ mt: 3, fontWeight: 600 }}>
                    Owner Details
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Owner Name"
                    fullWidth
                    value={ownerName}
                    onChange={(e) => setOwnerName(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Owner Mobile"
                    fullWidth
                    value={ownerMobile}
                    onChange={(e) => setOwnerMobile(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Owner Email"
                    fullWidth
                    value={ownerEmail}
                    onChange={(e) => setOwnerEmail(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Owner Address"
                    fullWidth
                    value={ownerAddress}
                    onChange={(e) => setOwnerAddress(e.target.value)}
                  />
                </Grid>

                {/* Reference Details */}
                {/* <Grid item xs={12}>
                  <Typography variant="h6" sx={{ mt: 3, fontWeight: 600 }}>
                    Reference Details
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Reference Name"
                    fullWidth
                    value={referenceName}
                    onChange={(e) => setReferenceName(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Reference Mobile"
                    fullWidth
                    value={referenceMobile}
                    onChange={(e) => setReferenceMobile(e.target.value)}
                  />
                </Grid> */}



              </>
            <Grid item xs={12}>
              <Typography fontWeight={600}>Property Description</Typography>
              <ReactQuill
                value={description}
                onChange={setDescription}
                modules={quillModules}
                formats={quillFormats}
                style={{ height: 200, marginBottom: 40 }}
              />
            </Grid>


            <Grid item xs={12}>
              <Typography
                variant="h6"
                sx={{ color: "#13216e", fontWeight: 600, fontSize: "20px" }}
              >
                Display Picture
              </Typography>

              {/* Custom Button for Display Image */}
              <label
                htmlFor="display-image-upload"
                style={{ cursor: "pointer", margin: "10px 15px" }}
              >
                <Button
                  variant="outlined"
                  color="primary"
                  component="span"
                  sx={{
                    borderColor: "primary.main",
                    color: "#fff",
                    backgroundColor: "#1565c0",
                    "&:hover": {
                      background: "#1565c0",
                      color: "rgba(25, 118, 210, 0.04)",
                      borderColor: "#1976d2",
                    },
                  }}
                >
                  Choose Display Image
                </Button>
              </label>

              <input
                id="display-image-upload"
                type="file"
                onChange={handleDisplayImageChange}
                style={{ display: "none" }} // Hide the default file input
              />

              {/* Show Preview */}
              {selectedImage && (
                <Box sx={{ mt: 2 }}>
                  <img
                    src={ImagePreview}
                    alt="Display"
                    style={{
                      width: "20%",
                      height: "20%",
                      objectFit: "cover",
                      margin: 5,
                      borderRadius: 8,
                    }}
                  />
                </Box>
              )}

              {/* Upload Button */}
              {/* {selectedImage && (
    <Button
      variant="contained"
      color="secondary"
      onClick={handleUpload} // Call handleUpload on click
      sx={{ mt: 2, backgroundColor: "#1976d2", color: "#fff" }}
    >
      Upload Image
    </Button> */}
              {/* )} */}

              {/* Display Errors if Any */}
              {propertyErrors.displayImage && (
                <Typography color="error">
                  {propertyErrors.displayImage}
                </Typography>
              )}
            </Grid>


            {(propertyType === "Property" || propertyType === "Individual Villa") && (
              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  sx={{ color: "#13216e", fontWeight: 600, fontSize: "20px" }}
                >
                  Gallery Images
                </Typography>
                <FileUploadWithPreview
                  handleFileChange={handleFileChange}
                  handleRemove={handleRemove}
                  previews={previews}
                  files={files}
                  fileInputRef={fileInputRef}
                />
                {propertyErrors.files && (
                  <Typography color="error">{propertyErrors.files}</Typography>
                )}
              </Grid>
            )}
           
<Grid item xs={12}>
  <Typography
    variant="h6"
    sx={{ color: "#13216e", fontWeight: 600, fontSize: "20px" }}
  >
    Property Videos (YouTube URL)
  </Typography>

  {youtubeLinks.map((link, index) => (
    <Box key={index} sx={{ display: "flex", gap: 2, mt: 1 }}>
      <TextField
        fullWidth
        label={`YouTube Link ${index + 1}`}
        placeholder="https://www.youtube.com/watch?v=XXXX"
        value={link}
        onChange={(e) => {
          const updated = [...youtubeLinks];
          updated[index] = e.target.value;
          setYoutubeLinks(updated);
        }}
      />

      {youtubeLinks.length > 1 && (
        <Button
          color="error"
          onClick={() =>
            setYoutubeLinks(youtubeLinks.filter((_, i) => i !== index))
          }
        >
          Remove
        </Button>
      )}
    </Box>
  ))}

  <Button sx={{ mt: 2 }} onClick={() => setYoutubeLinks([...youtubeLinks, ""])}>
    + Add Another Video
  </Button>

<Grid container spacing={2} sx={{ mt: 2 }}>
  {youtubeLinks.map((link, index) => {
    const embedUrl = getYoutubeEmbedUrl(link);
    if (!embedUrl) return null;

    return (
      <Grid item xs={12} sm={6} md={4} key={index}>
        <Box
          sx={{
            borderRadius: 2,
            overflow: "hidden",
            boxShadow: 2,
          }}
        >
          <iframe
            src={embedUrl}
            width="100%"
            height="200"
            style={{ border: "none" }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title={`youtube-${index}`}
          />
        </Box>
      </Grid>
    );
  })}
</Grid>
</Grid>


          </Grid>

          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={resetForm}
              sx={{ mr: 2 }}
            >
              Reset
            </Button>
            <Button type="submit" variant="contained" color="primary">
              Save Property
            </Button>
          </Box>
        </form>
      </Paper>
    </Box>
  );
};

export default AddPropertyModel;


